export default {
    locale: 'en',
    messages: {
        common: {
            register: 'Register',
            login: 'Login',
            'full-name': 'Full Name',
            email: 'Email',
            password: 'Password',
            send: 'Send',
            'send-code': 'Send code',
            logout: 'Logout',
        },
    },
};



// WEBPACK FOOTER //
// ./src/translations/en.js